import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../utils/redux';

export const consts = createReqConsts('communities', 'user-search', ['CLEAR']);
export const actions = createActions(consts);
export const watcher = createReqWatcher(
  consts,
  actions,
  {
    endpoint: 'communities',
    type: 'get',
    slug: [
      {
        type: 'payload',
        selector: ['communityId'],
      },
      'mass_invitations',
      'candidate_users',
      {
        type: 'payload.query',
        queryParameter: 'query',
        selector: 'query',
      },
      {
        type: 'payload.query',
        queryParameter: 'excluded_ids',
        selector: 'ids',
      },
      {
        type: 'payload.query',
        queryParameter: 'limit',
        selector: 'limit',
      },
    ],
  },
  true,
);

const reqReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case consts.CLEAR:
      return initialState;

    default:
      return reqReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/communities/invitationUserSearch.js